import { StatusPageLinkModule } from './statusPageLink.directive';
import { StatusSummaryModule } from './statusSummary.component';

export const StatusPageModule = angular
    .module('vln.statusPage', [
        StatusPageLinkModule,
        StatusSummaryModule
    ]).name;


// WEBPACK FOOTER //
// ./src/app/components/statusPage/statusPage.module.js